import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-application-page-resolver',
  templateUrl: 'application-page-resolver.html',
  encapsulation: ViewEncapsulation.None
})
export class ApplicationPageResolverComponent {
  productType: string;

  constructor(
    private activatedRoute: ActivatedRoute,
  ) {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.productType = params.get('productType').toLowerCase();
    });
  }
}
